import { Component, OnInit, OnDestroy,ViewChild  } from '@angular/core';
import { AlertService } from '../../servicios/alert.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { Result } from '../../servicios/servers.service';
import { TipoServicioService } from '../../servicios/tiposervicio.service';
import { PersonaService } from '../../servicios/persona.service';
import { VehiculoService } from '../../servicios/vehiculo.service';
import swal from 'sweetalert2';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { EmpresaService } from '../../servicios/empresa.service';
import { BsModalComponent,BsModalService  } from 'ng2-bs3-modal';
declare var jQuery: any;

@Component({
    selector: 'clientes',
    templateUrl: 'clientes.template.html'
})

export class ClientesComponent implements OnInit {
    
    constructor(
        private modalservice: BsModalService,
        private personaService: PersonaService,
        private alertService: AlertService,
        private tipoServicioService: TipoServicioService,
        private vehiculoService: VehiculoService,
        private empresaService: EmpresaService,
        private router: Router,
        private route: ActivatedRoute,
    ) {

    }

    @ViewChild('modal')
    public modal: BsModalComponent;
    public sub:any;
    public filter = "";
    public cliente:any;
    public aux: any;
    public vehiculo = null;
    public clientes = [];
    public empresas = [];
    public update = false;
    public valorRecarga = 0;
    
    ngOnInit() {

        this.getClientes();

    }
    
    files: FileList;
    getClientes() {
        loading_show();
        this.personaService.getAllByRol(4,(data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.clientes = data.Content;
            }

        });
    }

    getFiles(event: any) {
        this.files = event.target.files;
        for (var i = 0, f; f = this.files[i]; i++) {
            if (!f.type.match('image.*')) {
                continue;
            }
            var reader = new FileReader();
            reader.onload = (function (theFile) {
                return function (e) {
                    document.getElementById("image").innerHTML = ['<img class="animated bounceIn" style="width:60%; margin-left:20%" src="', e.target.result, '" />'].join('');
                };
            })(f);
            reader.readAsDataURL(f);
        }
    }

    

    /*showConductor(conductor: any) {
        this.conductor = conductor;
        this.update = true;
        this.buscarPlaca();
        jQuery("#clave").attr("disabled","disabled");
        jQuery("#t1").addClass("active");
        jQuery("#t2").removeClass("active");
        jQuery("#tab-1").addClass("active");
        jQuery("#tab-2").removeClass("active");
    }*/


    updateState(id: number, state: string) {
        loading_show();
        var object = {
            'id': id,
            'estado': state
        }

        this.personaService.updateState(object, (data: Result) => {
            loading_hide();
            if (data.isOk) {
                this.alertService.success("Estado actualizado");
                this.getClientes();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/views/clientes/clientes.component.ts